module.exports = __webpack_public_path__ + "static/media/codePieChart.267d690e.png";